import { STEP_STATUS } from '@typings/api-models';

type ThisWorkflowStep = {
  stepTaken?: { status: STEP_STATUS } | null;
};

const isStepCompleted = (step: ThisWorkflowStep): boolean => step?.stepTaken?.status === STEP_STATUS.SUCCEEDED;

export default isStepCompleted;